import RestFramework from "../lib/ra-rf";

const restFramework = new RestFramework(
  process.env.REACT_APP_API_URL as string
);

export default restFramework;
